import React, { useState, useEffect } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { SocialIcon } from "react-social-icons";

const Header = ({ isAuthenticated }) => {
  const [print, setprint] = useState(false);
  const [isCollapsed, setIsCollapsed] = useState(true);
  const navigate = useNavigate();

  const toggleNavbar = () => setIsCollapsed(!isCollapsed);
  const closeNavbar = () => setIsCollapsed(true);

  useEffect(() => {
    let username = sessionStorage.getItem("phone");
    if (!username) setprint(true);
  }, []);

  return (
    <header className="tj-header">
      <div className="container">
        <div className="row" style={{ maxHeight: "155px" }}>
          <div className="col-md-7 col-sm-6 col-xs-12 main-logo">
            <div
              className="tj-logo"
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "baseline",
              }}
            >
              <span>
                <img
                  className="cursor-pointer"
                  onClick={() => navigate("/")}
                  style={{
                    height: "100px",
                    margin: "auto",
                    marginTop: "20px",
                    display: "block",
                  }}
                  alt="logo"
                  src="images/logo.png"
                />
              </span>
            </div>
          </div>

          <div style={{ display: "block" }}>
              <span
                className="header-text"
                style={{
                  position: "absolute",
                  fontSize: 18,
                  fontWeight: 600,
                  padding: "24px 79px",
                  color: "#000",
                }}
              >
                Garuda – 24/7 Patient Ambulance Booking
              </span>

            <div
              className="social-css"
              style={{
                display: "flex",
                justifyContent: "space-between",
                textAlign: "center",
                padding: "70px",
              }}
            >
              <span className="social-media">
                <SocialIcon url="https://www.facebook.com/" />
              </span>
              <span className="social-media">
                <SocialIcon url="https://www.linkedin.com/" />
              </span>
              <span className="social-media">
                <SocialIcon url="https://www.instagram.com/" />
              </span>
              <span className="social-media">
                <SocialIcon url="https://x.com/" />
              </span>
              <span className="social-media">
                <SocialIcon url="https://www.youtube.com/" />
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* NAVIGATION */}
      <div className="tj-nav-row">
        <div className="container">
          <div className="row">
            <div className="tj-nav-holder">
              <nav className="navbar navbar-default">
                <div
                  className="navbar-header"
                  style={{ display: "flex", alignItems: "center", justifyContent: "center", width: "100%" }}
                >
                  {/* Hamburger menu on the left */}
                  <button
                    type="button"
                    className="navbar-toggle collapsed"
                    aria-expanded={!isCollapsed}
                    onClick={toggleNavbar}
                  >
                    <span className="sr-only">Menu</span>
                    <span className="icon-bar"></span>
                    <span className="icon-bar"></span>
                    <span className="icon-bar"></span>
                  </button>

                  {/* Single centered logo for mobile */}
                  <div className="logo-mobile-center">
                    <img
                      src="images/logo.png"
                      alt="Garuda Ambulance"
                      title="Garuda Ambulance"
                    />
                  </div>
                </div>

                <div
                  className={`collapse navbar-collapse ${
                    isCollapsed ? "" : "in"
                  }`}
                  id="tj-navbar-collapse"
                >
                  <ul className="nav navbar-nav">
                    <li onClick={closeNavbar}>
                      <NavLink
                        to="/"
                        className={({ isActive }) =>
                          isActive ? "active-nav1" : ""
                        }
                      >
                        Home
                      </NavLink>
                    </li>

                    <li onClick={closeNavbar}>
                      <NavLink
                        to="/about-us"
                        className={({ isActive }) =>
                          isActive ? "active-nav1" : ""
                        }
                      >
                        About Us
                      </NavLink>
                    </li>

                    <li onClick={closeNavbar}>
                      <NavLink
                        to="/services"
                        className={({ isActive }) =>
                          isActive ? "active-nav1" : ""
                        }
                      >
                        Services
                      </NavLink>
                    </li>

                    <li onClick={closeNavbar}>
                      <NavLink
                        to="/contact-us"
                        className={({ isActive }) =>
                          isActive ? "active-nav1" : ""
                        }
                      >
                        Contact Us
                      </NavLink>
                    </li>

                    {!isAuthenticated ? (
                      <li onClick={closeNavbar}>
                        <NavLink
                          to="/login"
                          className={({ isActive }) =>
                            isActive ? "active-nav1" : ""
                          }
                        >
                          Login
                        </NavLink>
                      </li>
                    ) : (
                      <li onClick={closeNavbar}>
                        <NavLink
                          to="/profile"
                          className={({ isActive }) =>
                            isActive ? "active-nav1" : ""
                          }
                        >
                          My Account
                        </NavLink>
                      </li>
                    )}

                    <li onClick={closeNavbar} className="logo-mobile-2">
                      <NavLink
                        to="/booknow"
                        className={({ isActive }) =>
                          isActive ? "active-nav1" : ""
                        }
                      >
                        Book Now <i className="fa fa-arrow-circle-right"></i>
                      </NavLink>
                    </li>
                  </ul>
                </div>
              </nav>

              <div className="book_btn">
                <NavLink
                  to="/booknow"
                  className={({ isActive }) =>
                    isActive ? "" : ""
                  }
                >
                  Book Ambulance{" "}
                  <i className="fa fa-arrow-circle-right"></i>
                </NavLink>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
